import React from 'react';

import './ShoppingLink.scss';
import icons from '../../shared/assets/icons';

const { ShoppingCart } = icons;

export default function ShoppingLink(props) {
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="shoppingLink"
      href={props.link.replace(/&amp;/g, '&')}
    >
      {props.label}

      <ShoppingCart />
    </a>
  );
}
